import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { useEffect, Component } from "react";
import LandingPage from "./pages/LandingPage";
import SuccessPage from "./pages/SuccessPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";

// Error boundary: if React crashes, show a minimal fallback instead of blank page
class AppErrorBoundary extends Component {
    constructor(props) { super(props); this.state = { hasError: false }; }
    static getDerivedStateFromError() { return { hasError: true }; }
    componentDidCatch(err) { console.error("React render error:", err); }
    render() {
        if (this.state.hasError) {
            // Check if SSR content exists and restore it
            const ssrContent = document.querySelector('[data-ssr="true"]');
            if (ssrContent) return null; // Let SSR content stay visible
            return (
                <div style={{minHeight:"100vh",background:"#0A0A0A",color:"#E5E5E5",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"sans-serif"}}>
                    <div style={{textAlign:"center",padding:"40px"}}>
                        <h1 style={{fontSize:"24px",marginBottom:"16px"}}>Something went wrong</h1>
                        <p style={{color:"#A3A3A3",marginBottom:"24px"}}>Please try refreshing the page or disabling your ad blocker.</p>
                        <button onClick={() => window.location.reload()} style={{background:"#D4AF37",color:"#0A0A0A",padding:"12px 32px",border:"none",borderRadius:"8px",fontWeight:"700",cursor:"pointer",fontSize:"16px"}}>Reload Page</button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

// Meta Pixel page view tracker for SPA navigation
const MetaPixelTracker = () => {
    const location = useLocation();
    
    useEffect(() => {
        // Skip admin pages
        if (location.pathname.startsWith('/admin')) return;
        
        // Track page view on route change
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
    }, [location]);
    
    return null;
};

function App() {
    return (
        <AppErrorBoundary>
        <HelmetProvider>
            <div className="App">
                <div className="noise-overlay" />
                <Toaster 
                    position="top-right" 
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: '#0A0A0A',
                            border: '1px solid #333333',
                            color: '#E5E5E5',
                        },
                    }}
                />
                <BrowserRouter>
                    <MetaPixelTracker />
                    <Routes>
                        {/* Default redirect to first product */}
                        <Route path="/" element={<Navigate to="/ebook-lastlonger" replace />} />
                        
                        {/* Product landing pages - dynamic by tag */}
                        <Route path="/:productTag" element={<LandingPage />} />
                        <Route path="/:productTag/success" element={<SuccessPage />} />
                        
                        {/* Admin routes */}
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        <Route path="/admin/dashboard/:productTag" element={<AdminDashboard />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </HelmetProvider>
        </AppErrorBoundary>
    );
}

export default App;
